import { useMemo, useState } from 'react'
import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { SelectValue } from 'antd/es/select'
import { Option, Select } from 'components/Select'
import { useAppSelector } from 'store'
import stringComparator from 'utils/stringComparator'

export const TicketReporterFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const users = useAppSelector((state) => state.identity.administrationUsers) ?? []

  const sortedUsers = useMemo(
    () => [...users].sort((a, b) => stringComparator(a.name, b.name)),
    [users]
  )
  const [selectedUsers, setSelectedUsers] = useState<SelectValue>([])
  const selectValue = filter.value ?? selectedUsers

  return (
    <Select
      placeholder='Reporter'
      value={selectValue}
      onChange={(value: SelectValue) => {
        const userValue = value || []
        setSelectedUsers(userValue)
        onFilterChange.call(undefined, {
          nextFilter: { ...filter, value: userValue },
        })
      }}
      showSearch
      style={{ width: '180px' }}
    >
      {sortedUsers.map((user) => (
        <Option value={user.id} key={user.id}>
          {user.name}
        </Option>
      ))}
    </Select>
  )
}
